/**
 * @generated SignedSource<<f1529dd1894cfa267334b674b822c553>>
 * @relayHash 2be08b7de0a8585d7b7b94f81064a805
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2be08b7de0a8585d7b7b94f81064a805

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type NotBillableReason = "ADMINISTRATIVE" | "INCOMPLETE_CONSULTATION" | "OTHER_REASON";
export type TreatmentReason = "ACCIDENT" | "CONGENITAL_DEFECT" | "MATERNITY" | "PREVENTION" | "SICKNESS";
export type ReConcludeAppointmentInput = {
  collectBillingInput: CollectBillingDataInput;
  id: string;
  inboundCallId?: number | null;
  isEditWithin24Hours: boolean;
  progressNoteIds: ReadonlyArray<string>;
};
export type CollectBillingDataInput = {
  accidentReference?: string | null;
  appointmentId: string;
  currentGestationWeek?: number | null;
  dateOfAccident?: any | null;
  isEmployer?: boolean | null;
  isNotBillable: boolean;
  isPatientPregnant?: boolean | null;
  isVisualSymptomExamination?: boolean | null;
  ivgCaseReference?: string | null;
  notBillableReason?: NotBillableReason | null;
  organisationId?: string | null;
  patientAge?: number | null;
  patientOrganisationKey?: string | null;
  reason?: string | null;
  treatmentReason?: TreatmentReason | null;
};
export type useReConcludeAppointmentMutation$variables = {
  input: ReConcludeAppointmentInput;
};
export type useReConcludeAppointmentMutation$data = {
  readonly reConcludeAppointment: {
    readonly appointment: {
      readonly completedAt: string | null;
      readonly id: string;
      readonly isCompleted: boolean;
      readonly status: AppointmentStatus;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useReConcludeAppointmentMutation = {
  response: useReConcludeAppointmentMutation$data;
  variables: useReConcludeAppointmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReConcludeAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ReConcludeAppointmentPayload",
        "kind": "LinkedField",
        "name": "reConcludeAppointment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useReConcludeAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ReConcludeAppointmentPayload",
        "kind": "LinkedField",
        "name": "reConcludeAppointment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2be08b7de0a8585d7b7b94f81064a805",
    "metadata": {},
    "name": "useReConcludeAppointmentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ebe490e5aec6e7115a8104a8c4ff38ba";

export default node;
